/**
 * Points a URL of the station host (e.g. http://10.210.50.2:5000/) at the host the UI was opened
 * through, so links keep working when the station is reached through router port forwarding
 * (e.g. http://192.168.88.120/). URLs of other hosts are returned unchanged.
 */
export default function toBrowserHost(url, stationHostUrl) {
  if (!url || !stationHostUrl) return url || '';

  try {
    const target = new URL(url);
    const stationHost = new URL(stationHostUrl).hostname;

    if (target.hostname !== stationHost) return url;

    target.hostname = window.location.hostname;
    return target.toString();
  } catch {
    return url;
  }
}
